(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-enhanced-animated"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    var footer = document.querySelector('.footer-content');
    if (!footer) return;

    var blocks = footer.querySelectorAll('[data-block-handle]');
    if (!blocks.length) return;

    // Intersection Observer for scroll-triggered entrance
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -40px 0px',
      threshold: 0.1
    });

    blocks.forEach(function(block, index) {
      // Set stagger delay as inline style for precise control
      var stagger = parseInt(getComputedStyle(footer).getPropertyValue('--stagger-delay')) || 80;
      block.style.transitionDelay = (index * stagger) + 'ms';
      observer.observe(block);
    });

    // Parallax subtle effect on mouse move (desktop only)
    var isTouch = window.matchMedia('(pointer: coarse)').matches;
    if (!isTouch && blocks.length > 2) {
      footer.addEventListener('mousemove', function(e) {
        var rect = footer.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;

        blocks.forEach(function(block, i) {
          var depth = (i % 3 + 1) * 0.5;
          var moveX = x * depth;
          var moveY = y * depth;
          if (block.classList.contains('is-visible')) {
            block.style.transform = 'translate(' + moveX + 'px, ' + moveY + 'px)';
          }
        });
      });

      footer.addEventListener('mouseleave', function() {
        blocks.forEach(function(block) {
          if (block.classList.contains('is-visible')) {
            block.style.transform = '';
          }
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    var footer = document.querySelector('.footer-content');
    if (!footer) return;

    var blocks = footer.querySelectorAll('[data-block-handle]');
    if (!blocks.length) return;

    // Simple Intersection Observer — NO parallax, NO mousemove
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -60px 0px',
      threshold: 0.05
    });

    blocks.forEach(function(block, index) {
      var stagger = parseInt(getComputedStyle(footer).getPropertyValue('--stagger-delay')) || 80;
      block.style.transitionDelay = (index * stagger) + 'ms';
      observer.observe(block);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mgl-how-we-work"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    var timelines = document.querySelectorAll('.hw-timeline');
    if (!timelines.length) return;

    timelines.forEach(function(timeline) {
      var steps = timeline.querySelectorAll('.hw-step');
      if (!steps.length) return;

      // Intersection Observer for entrance animation
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        root: null,
        rootMargin: '0px 0px -60px 0px',
        threshold: 0.15
      });

      steps.forEach(function(step) {
        observer.observe(step);

        // Click to expand detail
        step.addEventListener('click', function() {
          var wasActive = step.classList.contains('active');
          steps.forEach(function(s) { s.classList.remove('active'); });
          if (!wasActive) {
            step.classList.add('active');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
